import React from "react";
import DRLogo from "../../assets/images/DR-Finincial-Logo.svg";

const Header = () => {
  return (
    <>
      <header className="header">
        <div className="container">
          <a href="/">
            <img src={DRLogo} alt="DR logo" />
          </a>
        </div>
      </header>
    </>
  );
};

export default Header;
